import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetFixedAssetsPageDataInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

/**
 * Aggregate server function for the fixed assets index page.
 *
 * Fetches fixed assets list and business detail in a single HTTP round trip
 * on client-side navigation.
 */
export const getFixedAssetsPageData = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetFixedAssetsPageDataInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("fixedAssets.pageData", async () => {
      const [businessMod, fixedAssetsMod] = await Promise.all([
        import("../business/business.server"),
        import("./fixed-assets.server"),
      ]);
      const { getBusinessDetailForUser } = businessMod;
      const { listFixedAssetsForUser } = fixedAssetsMod;

      const [businessDetail, assets] = await Promise.all([
        getBusinessDetailForUser(context.user.id, data.businessId),
        listFixedAssetsForUser(context.user.id, data.businessId, {
          limit: 20,
        }),
      ]);

      return { businessDetail, assets } as const;
    });
  });
